import React from 'react';
import { generateTimes } from '../helpers/schedules';

const generateOptionsFromInterval = minInterval => generateTimes(true, minInterval).map(time => (
  <option
    value={time}
    key={time}
  >
    {time}
  </option>
));

export default generateOptionsFromInterval;
